import { PixiContext } from "common/pixi";
import { createApplication, createCenterContainer } from "common/pixi/app";
import { Waiter } from "common/promises";
import { ReesizeEventHandler } from "common/resize";
import { Sheet } from "common/sheet";
import * as R from "ramda";
import { letterbox } from "seventh-animation/screen";
import * as LoadingAnimation from "./loadingAnimation";
import { Background, Button, Title, toPath } from "./resources";
export class Scene {
    async start({ parentSelector, sound, transitionImage, }) {
        const resizer = new ReesizeEventHandler();
        letterbox(resizer);
        const app = createApplication(parentSelector, transitionImage);
        const sheets = await Promise.all(R.compose(R.map((n) => {
            return Sheet.load(toPath(`sheet${n}.png`), toPath(`sheet${n}.json`));
        }), R.range)(0, 7));
        const pixiContext = new PixiContext(app);
        const elements = loadAllElements({ pixiContext, sheets });
        addElementsToScene({ elements, app });
        transitionImage === null || transitionImage === void 0 ? void 0 : transitionImage.dispose();
        const buttonAnimation = elements.button.animate();
        await LoadingAnimation.run({ elements, sound, pixiContext });
        const waiter = new Waiter();
        elements.button.callback = async () => {
            waiter.trigger();
        };
        await waiter.wait();
        await elements.button.dispose();
        buttonAnimation.canceler.cancel();
        sound.stopLoop("background");
        sound.stopLoop("pleaseClick");
        sound.dispose();
        pixiContext.dispose();
        app.destroy(true);
        PIXI.utils.destroyTextureCache();
        $("#pixi-canvas").remove();
        await buttonAnimation.promise;
        resizer.drop();
    }
}
function loadAllElements({ sheets, pixiContext, }) {
    return {
        background: new Background(pixiContext, sheets),
        title: new Title(pixiContext, sheets),
        button: new Button(pixiContext, sheets),
    };
}
function addElementsToScene({ elements: { background, title, button }, app, }) {
    const centerContainer = createCenterContainer();
    app.stage.addChild(centerContainer);
    const pixiObjects = [background.sprite, title.sprite, button.sprite];
    for (const pixiObject of pixiObjects) {
        pixiObject.visible = false;
        centerContainer.addChild(pixiObject);
    }
}
//# sourceMappingURL=main.js.map